import Vue from 'vue';
import VueQuillEditor, { Quill } from 'vue-quill-editor';
// eslint-disable-next-line import/no-extraneous-dependencies,import/first
import 'quill/dist/quill.core.css';
// eslint-disable-next-line import/no-extraneous-dependencies,import/first
import 'quill/dist/quill.snow.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.bubble.css';
// eslint-disable-next-line import/no-extraneous-dependencies,import/first
import Video from '@/util/quill/video';
// eslint-disable-next-line import/first
import Audio from '@/util/quill/audio';
// eslint-disable-next-line import/first
import Img from '@/util/quill/img';

Quill.register(Video, true);
Quill.register(Audio, true);
Quill.register(Img, true);
Vue.use(VueQuillEditor);



// WEBPACK FOOTER //
// ./src/util/quill/quill.js